import React from 'react';

const SpecialtiesSection = () => {
  return (
    <section className="py-16 bg-swastik-lightEarth/20">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-4">Our Specialties</h2>
          <p className="text-lg text-gray-600">
            Effective Natural Treatments for Chronic Diseases
          </p>
          <p className="text-gray-600 mt-4">
            We combine ancient Ayush wisdom with modern medical understanding to provide holistic healing for conditions that often have limited options in conventional natural medicine.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SpecialtiesSection; 